import { Reducer } from 'redux';
import { ProcessStepCodesEnum } from 'app/features/Member/Forget/types';
import { MEMBER_FORGET__RESEND_OTP_DONE, ForgetState, ForgetActions, MEMBER_FORGET__SET_ACCESSIBLE_STEP, MEMBER_FORGET__FETCH_CAPTCHA_DONE, MEMBER_FORGET__SAVE_AUTH_PAGE_DATA, MEMBER_FORGET__SEND_OTP_DONE, MEMBER_FORGET__SAVE_TEMPORARY_AUTHORIZATION, MEMBER_FORGET__UPDATE_CACHE, MEMBER_FORGET__RESET_CACHE } from './types';

const initialState: ForgetState = {
  static: {},
  process: {
    accessibleSteps: [ProcessStepCodesEnum.Auth],
    auth: {
      otpAuth: {}
    }
  }
};

const forgetReducer: Reducer<ForgetState, ForgetActions> = (state = initialState, action): ForgetState => {
  switch (action.type) {
    // 設置可訪問步驟
    case MEMBER_FORGET__SET_ACCESSIBLE_STEP: {
      const currentStep = action.payload.step;
      const accessibleSteps = state.process.accessibleSteps.filter((step) => step !== currentStep).concat(currentStep);
      return { ...state, process: { ...state.process, accessibleSteps } };
    }
    // 取得圖形驗證碼 完成
    case MEMBER_FORGET__FETCH_CAPTCHA_DONE: {
      return { ...state, static: { ...state.static, captcha: action.payload.response } };
    }
    // 緩存「輸入基本資料」(Step-1-1) 頁面資料
    case MEMBER_FORGET__SAVE_AUTH_PAGE_DATA: {
      return { ...state, process: { ...state.process, auth: { ...state.process.auth, data: action.payload.data } } };
    }
    // 發送 OTP 驗證碼 完成
    case MEMBER_FORGET__SEND_OTP_DONE:
    case MEMBER_FORGET__RESEND_OTP_DONE: {
      return { ...state, process: { ...state.process, auth: { ...state.process.auth, otpAuth: { ...state.process.auth.otpAuth, otp: action.payload.response } } } };
    }
    // 緩存暫時性「會員主檔」和「Access Token」
    case MEMBER_FORGET__SAVE_TEMPORARY_AUTHORIZATION: {
      return { ...state, static: { ...state.static, temporaryAuthorization: action.payload.authorization } };
    }
    // 更新資料緩存
    case MEMBER_FORGET__UPDATE_CACHE: {
      return { ...action.payload.cache };
    }
    // 重置資料緩存
    case MEMBER_FORGET__RESET_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default forgetReducer;
